import fromPairs from 'lodash/fromPairs';

import convertToOption from '../utils/convert-to-option';
import pluralize from '../utils/pluralize';

export const IO = 'IO';
export const SIGNED_IO = 'Signed IO';
export const IO_AMENDMENT = 'IO Amendment';
export const SIGNED_IO_AMENDMENT = 'Signed IO Amendment';
export const AFA = 'AFA';
export const OTHER = 'Other';
export const CONDITIONS = 'WKZ / Conditions';
export const PARTNER_INFORMATION = 'Partner Information';
export const SIDE_LETTER = 'Side Letter';
export const INVOICE = 'Invoice';

export const commonAttachmentTypes = [
  { label: AFA, value: AFA },
  { label: OTHER, value: OTHER },
];
export const accountAttachmentTypes = [
  { label: CONDITIONS, value: CONDITIONS },
  { label: SIDE_LETTER, value: SIDE_LETTER },
  { label: PARTNER_INFORMATION, value: PARTNER_INFORMATION },
  ...commonAttachmentTypes,
];
export const iOAmendmentTypes = [
  { label: IO_AMENDMENT, value: IO_AMENDMENT },
  { label: SIGNED_IO_AMENDMENT, value: SIGNED_IO_AMENDMENT },
];
export const opportunityAttachmentTypes = [
  { label: IO, value: IO },
  { label: SIGNED_IO, value: SIGNED_IO },
  ...iOAmendmentTypes,
  ...commonAttachmentTypes,
];

export const ACCOUNT = 'account';
export const OPPORTUNITY = 'opportunity';
export const AGREEMENT = 'agreement';
export const COMMENT = 'comment';
export const ALL_ATTACHMENT_TYPES = [
  IO,
  SIGNED_IO,
  IO_AMENDMENT,
  SIGNED_IO_AMENDMENT,
  CONDITIONS,
  SIDE_LETTER,
  PARTNER_INFORMATION,
  OTHER,
  AFA,
  INVOICE,
];

export const CONTENT_TYPE_TO_ATTACHMENT_TYPES = {
  [ACCOUNT]: accountAttachmentTypes,
  [OPPORTUNITY]: opportunityAttachmentTypes,
  [AGREEMENT]: [CONDITIONS, SIDE_LETTER, OTHER].map(convertToOption),
};

export const ATTACHMENT_LABELS = fromPairs(
  ALL_ATTACHMENT_TYPES.map(type => [type, pluralize(type)]),
);

export const AttachmentAssociationLabel = object => object.name;
export const attachmentAssociationFilterFields = ['name'];
